import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { ButtonLink } from '../ButtonLink/ButtonLink';

interface PermissionsNotFoundProps {
    accessPointCode: string;
    translations: Record<string, string>;
}

export const PermissionsNotFound: React.FC<PermissionsNotFoundProps> = ({ accessPointCode, translations }) => (
    <Box mt={8} textAlign="center">
        <Typography variant="h4">{translations.GLOBAL_ERROR_TITLE}</Typography>
        <Typography variant="subtitle2">{translations.ERROR_404}</Typography>
        <Box mt={8}>
            <ButtonLink
                to={`/accesspoint/${accessPointCode}`}
                text={translations.PERMISSIONS_BACK_TO_ACCESS_POINT_BUTTON}
                icon={<ArrowBackIcon />}
            />
        </Box>
    </Box>
);
